<template>
	<input
		@change="handleChangeVideo"
		type="file"
		accept="video/*">
</template>

<script>
export default {
    methods: {
        handleChangeVideo( e ) {
            if ( e.target.files && e.target.files.length > 0 ) {
                const file = e.target.files[0];

                const formData = new FormData( );
                formData.append( "file", file );
                const params = formData;
                this.$apis.uploadFileRequest( { params } ).then( res => {
                    this.$emit( "success", res.fileUrl );
                } ).catch( console.log );
            }
        }

    }
};
</script>
<style lang="less" scoped>
input{
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    top: 0;
    left: 0;
}
</style>
